module.exports = __webpack_public_path__ + "media/images/illustrations/StarWorks-Hero_02_Rocket-46ed974fe47049cc83546cf5f9286429.png";